<template>
	<div>
		<el-dialog :visible.sync="showQuestion" width="527" center :show-close="true" title="意见反馈">
			<div class="dialogFeed">
				<div class="navs flex flex-b">
					<div class="navItem flex flex-c-c pointer" :class="type==1?'active':''" @click="type=1">机器售后
					</div>
					<div class="navItem flex flex-c-c pointer" :class="type==2?'active':''" @click="type=2">用户反馈
					</div>
				</div>
				<div class="opinion"><span>*</span>问题描述</div>
				<el-input type="textarea" placeholder="请详细描述您遇到的问题..." v-model="content" maxlength="200"
					show-word-limit>
				</el-input>
				<div class="opinion">上传图片</div>
				<div class="t" style="margin-bottom: 30px;">最多可上传 3 张图片，支持 jpg、png 格式</div>
				<div class="flex ">
					<div class="rel flex flex-b" v-for="(item,index) in imgList" style="width: 136px;height: 136px;">
						<img :src="item" alt="" style="width: 136px;height: 136px;border-radius: 9px;" />
						<img class="delect pointer" @click="imgList.splice(index,1)" src="../../src/assets/images/home/delect.png"
							style="width: 22px;height: 22px;" alt="" />
					</div>

					<el-upload :limit="3" class="avatar-uploader" style="margin-left: 30px;" :action="uplodUrl" :show-file-list="false"
						:on-success="handleAvatarSuccess">
						<div class="img flex flex-c-c" v-if="imgList.length<3">
							<img src="../../src/assets/images/home/imgIcon.png" style="width: 36px;height: 36px;"
								alt="" />
						</div>
					</el-upload>
				</div>
				<div class="opinion">联系方式</div>
				<input type="text" placeholder="请输入手机号码" v-model="phone" />
				<div class="login-btn pointer" @click="toFeedback">
					<span class="text">提交反馈</span>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		urlDomain,
		imgDomain
	} from '@/configs/env.js'
	import {
		toFeedback
	} from '@/api/common';
	export default {
		data() {
			return {
				showQuestion: false,
				content: '',
				imgList: [],
				type: 1,
				phone: '',
				uplodUrl: ''
			}
		},
		mounted() {
			this.uplodUrl = urlDomain + '/v1/common/Upload'
		},
		methods: {
			handleAvatarSuccess(res, file) {
				this.imgList.push(imgDomain + res.result)
			},
			async toFeedback() {
				if (!this.content) {
					this.$message({
						message: '请填写反馈内容',
						type: 'warning'
					});
					return
				}
				const {
					status,
					data
				} = await toFeedback({
					content: this.content,
					phone: this.phone,
					type: this.type,
					img: this.imgList,
				})
				if (status !== 200) return;
				this.$message({
					message: '反馈已成功提交，感觉您的提交！',
					type: 'success'
				});
				this.showQuestion = false
				this.imgList = []
				this.content = ''
				this.phone = ''
				this.type=1
			},
			openDialog() {
				this.showQuestion = true
			},
		}
	}
</script>

<style lang="less" scoped>
	.login-btn {
		width: 100%;
		height: 59px;
		background: url('../assets/images/login/loginbtn.png') no-repeat;
		background-size: 100% 100%;
		margin-top: 13px;
		display: flex;
		align-items: center;
		justify-content: center;

		.text {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 600;
			font-size: 16px;
			text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
			text-align: center;
			font-style: normal;
			text-transform: none;
			background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
		}
	}

	.dialogFeed {
		.navs {
			.navItem {
				width: 48%;
				height: 40px;
				background: #FFFFFF;
				border-radius: 13px 13px 13px 13px;
				border: 1px solid #EEEEEE;
				opacity: 0.8;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
			}

			.active {
				background: rgba(0, 167, 60, 0.06);
				border-radius: 13px 13px 13px 13px;
				color: #00A73C;
			}
		}

		.opinion {
			margin: 10px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #000000;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #FC5F5F;
			}
		}

		input {
			width: 100%;
			padding: 0 20px;
			height: 44px;
			background: #F7F8F9;
			border-radius: 11px 11px 11px 11px;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #000;
			line-height: 44px;
			border: none;

			&:focus {
				outline: none;
			}
		}

		.t {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 13px;
			color: #666666;
		}

		.img {
			width: 136px;
			height: 136px;
			background: #F8F8FA;
			border-radius: 9px 9px 9px 9px;
		}

		.rel {
			position: relative;

			.delect {
				position: absolute;
				top: -6px;
				right: -6px;
			}
		}

		.wbox {
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 16px;
			margin-bottom: 6px;

			.tit {
				margin-bottom: 6px;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 18px;
				color: #000000;
			}

			.tit2 {
				padding: 3px 0;
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #666666;
			}
		}
	}

	::v-deep .el-dialog__header {
		padding: 20px 20px 10px !important;
	}

	::v-deep .el-dialog__body {
		padding: 25px 25px 30px !important;
	}

	::v-deep .el-dialog__close:hover {
		color: #999;
	}

	::v-deep .el-dialog__headerbtn {
		font-size: 24px;
	}
</style>